import type { PhoneInputValue } from '@libs/ui/ds'
import { phoneInputUtils } from '@libs/ui/ds'
import { useComponentsTranslation } from '@libs/utils/translations'
import * as yup from 'yup'

export const fixedPhoneValidator = (value: PhoneInputValue) => {
  if (value?.number === '') {
    return true
  }

  // When the length of the phone number is less than 3, returns error
  const tooShort = value?.number.length <= 3
  if (tooShort) {
    return false
  }

  return phoneInputUtils.isValidFixedLine(value)
}

export const useYupFixedPhoneValidator = (errorMsg?: string) => {
  const { t } = useComponentsTranslation()

  return yup
    .object({
      number: yup.string(),
      countryCode: yup.string()
    })
    .test(
      'mobile_phone',
      errorMsg || t('components.fieldPhoneNumber.formatError'),
      value => {
        return fixedPhoneValidator(value)
      }
    )
}
